import { createContext } from 'react';

export type RoutingOptions = {
  route: (path: string) => void;
};

export const RoutingContext = createContext<RoutingOptions>({
  route: () => {},
});
